var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-landpay-d",
    xmlns: "http://www.w3.org/2000/svg",
    width: 126.146,
    height: 30.256,
    viewBox: "0 0 126.146 30.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6609",
    "data-name": "Group 6609",
    transform: "translate(36.613 10.585)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13128",
    "data-name": "Path 13128",
    d: "M297.25,264.38h3.356v11.533h7.058v3.051H297.25Z",
    transform: "translate(-297.25 -264.38)",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13129",
    "data-name": "Path 13129",
    d: "M365.82,282.3V293l-3.08.065.028-1.1a3.923,3.923,0,0,1-1.282,1.008,3.859,3.859,0,0,1-1.709.357,5.205,5.205,0,0,1-1.882-.357,4.915,4.915,0,0,1-1.669-1.078,5.44,5.44,0,0,1-1.2-1.79,6.188,6.188,0,0,1-.458-2.451,6.03,6.03,0,0,1,.468-2.461,5.44,5.44,0,0,1,1.231-1.78,5.2,5.2,0,0,1,1.7-1.088,5.113,5.113,0,0,1,1.872-.367,4,4,0,0,1,1.86.377,3.046,3.046,0,0,1,1.068.845l-.123-.875h3.174Zm-4.67,2.888a2.361,2.361,0,0,0-.925-.183,2.283,2.283,0,0,0-.915.183,2.365,2.365,0,0,0-.762.528,2.49,2.49,0,0,0-.528.834,3.215,3.215,0,0,0,0,2.2,2.4,2.4,0,0,0,.528.824,2.525,2.525,0,0,0,.774.528,2.215,2.215,0,0,0,.9.193,2.259,2.259,0,0,0,.925-.193,2.548,2.548,0,0,0,.774-.528,2.386,2.386,0,0,0,.528-.824,3.215,3.215,0,0,0,0-2.2,2.53,2.53,0,0,0-.528-.834A2.328,2.328,0,0,0,361.151,285.191Z",
    transform: "translate(-343.017 -278.417)",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13130",
    "data-name": "Path 13130",
    d: "M419.287,283.405a4.208,4.208,0,0,1,1.352-1.038,4.3,4.3,0,0,1,1.963-.427,3.888,3.888,0,0,1,2.908,1.1,4.054,4.054,0,0,1,1.078,2.971v6.978h-3.255v-6.1a2.078,2.078,0,0,0-.458-1.393,1.7,1.7,0,0,0-1.373-.538,1.884,1.884,0,0,0-1.659.814,3.47,3.47,0,0,0-.56,2.013v5.208H416.03v-10.7h3.477Z",
    transform: "translate(-392.09 -278.401)",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13131",
    "data-name": "Path 13131",
    d: "M485.246,278.964l-3.1.073.052-1.109a3.913,3.913,0,0,1-2.951,1.362,5.248,5.248,0,0,1-1.9-.357,4.679,4.679,0,0,1-1.647-1.078,5.5,5.5,0,0,1-1.169-1.79,6.3,6.3,0,0,1-.447-2.451,6.169,6.169,0,0,1,.458-2.461,5.678,5.678,0,0,1,1.179-1.78,4.91,4.91,0,0,1,3.447-1.455,3.94,3.94,0,0,1,1.709.324,3.662,3.662,0,0,1,1.119.814V264.38h3.255Zm-4.628-7.81a2.361,2.361,0,0,0-.925-.183,2.283,2.283,0,0,0-.915.183,2.243,2.243,0,0,0-.752.528,2.448,2.448,0,0,0-.508.834,3.14,3.14,0,0,0-.183,1.1,3.086,3.086,0,0,0,.183,1.1,2.394,2.394,0,0,0,.508.824,2.426,2.426,0,0,0,.762.528,2.214,2.214,0,0,0,.9.193,2.258,2.258,0,0,0,.925-.193,2.381,2.381,0,0,0,.762-.528,2.317,2.317,0,0,0,.508-.824,3.381,3.381,0,0,0,0-2.2,2.521,2.521,0,0,0-.508-.834A2.169,2.169,0,0,0,480.618,271.154Z",
    transform: "translate(-438.44 -264.38)",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13132",
    "data-name": "Path 13132",
    d: "M535.07,282.295h3.316l-.264,1.038a3.388,3.388,0,0,1,1.292-.986,4.473,4.473,0,0,1,1.923-.4,4.767,4.767,0,0,1,1.84.367,4.483,4.483,0,0,1,1.566,1.088,5.388,5.388,0,0,1,1.088,1.78,6.816,6.816,0,0,1,.407,2.461,6.683,6.683,0,0,1-.417,2.461,5.246,5.246,0,0,1-1.129,1.78A4.5,4.5,0,0,1,543,292.965a5.939,5.939,0,0,1-2.054.357,4.623,4.623,0,0,1-.711-.06,5.426,5.426,0,0,1-.752-.173,3.355,3.355,0,0,1-.671-.284,1.533,1.533,0,0,1-.488-.417v4.474h-3.255V282.295Zm4.628,7.8a2.267,2.267,0,0,0,.925.193,2.192,2.192,0,0,0,.915-.193,2.43,2.43,0,0,0,.752-.528,2.46,2.46,0,0,0,.518-.824,3.215,3.215,0,0,0,0-2.2,2.647,2.647,0,0,0-.518-.834,2.169,2.169,0,0,0-.762-.528,2.306,2.306,0,0,0-.9-.183,2.354,2.354,0,0,0-.925.183,2.2,2.2,0,0,0-.762.528,2.447,2.447,0,0,0-.508.834,3.382,3.382,0,0,0,0,2.2,2.4,2.4,0,0,0,.508.824A2.428,2.428,0,0,0,539.7,290.095Z",
    transform: "translate(-487.138 -278.409)",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13133",
    "data-name": "Path 13133",
    d: "M607.38,282.295v10.7h-3.029l-.022-1.038a3.921,3.921,0,0,1-1.282,1.008,3.859,3.859,0,0,1-1.709.357,5.206,5.206,0,0,1-1.882-.357,4.915,4.915,0,0,1-1.669-1.078,5.439,5.439,0,0,1-1.2-1.79,6.186,6.186,0,0,1-.458-2.451,6.029,6.029,0,0,1,.468-2.461,5.44,5.44,0,0,1,1.231-1.78,5.2,5.2,0,0,1,1.7-1.088,5.114,5.114,0,0,1,1.872-.367,4,4,0,0,1,1.86.377,3.045,3.045,0,0,1,1.068.844l-.276-.875h3.328Zm-4.67,2.888a2.36,2.36,0,0,0-.925-.183,2.283,2.283,0,0,0-.915.183,2.368,2.368,0,0,0-.762.528,2.493,2.493,0,0,0-.528.834,3.217,3.217,0,0,0,0,2.2,2.409,2.409,0,0,0,.528.824,2.526,2.526,0,0,0,.774.528,2.214,2.214,0,0,0,.9.193,2.259,2.259,0,0,0,.925-.193,2.527,2.527,0,0,0,.774-.528,2.386,2.386,0,0,0,.528-.824,3.215,3.215,0,0,0,0-2.2,2.531,2.531,0,0,0-.528-.834A2.281,2.281,0,0,0,602.71,285.183Z",
    transform: "translate(-535.891 -278.409)",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13134",
    "data-name": "Path 13134",
    d: "M661.994,293.83,657.6,283.66h3.723l2.34,5.716,2.157-5.716h3.642l-4.678,11.8a6.283,6.283,0,0,1-.794,1.5,4.588,4.588,0,0,1-.945.965,3.059,3.059,0,0,1-1.048.508,4.537,4.537,0,0,1-1.139.143,6.318,6.318,0,0,1-1.312-.123,5.447,5.447,0,0,1-1.008-.3l.855-2.787a1.867,1.867,0,0,0,.528.183,3.237,3.237,0,0,0,.631.06,1.15,1.15,0,0,0,.641-.193,1.59,1.59,0,0,0,.518-.8Z",
    transform: "translate(-584.972 -279.774)",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6608",
    "data-name": "Group 6608",
    transform: "translate(85.038 1.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13135",
    "data-name": "Path 13135",
    d: "M719.17,272.8H721v.377h-.7v1.895h-.421v-1.895h-.7Z",
    transform: "translate(-719.17 -272.8)",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13136",
    "data-name": "Path 13136",
    d: "M731.708,272.8h.492v2.271h-.4v-1.5l-.552,1.5h-.441l-.552-1.5v1.5h-.4V272.8h.488l.677,1.862Z",
    transform: "translate(-727.706 -272.8)",
    fill: "#a1a1a1"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6611",
    "data-name": "Group 6611",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13137",
    "data-name": "Path 13137",
    d: "M145.353,220.893h.079l-3.019-6.842a3.116,3.116,0,0,0-4.148-1.557l-1.51.692-2.467-1.832a6.034,6.034,0,0,0-7.159,0l-9.162,6.827a5.835,5.835,0,0,0-2.376,4.7v11.664a5.923,5.923,0,0,0,5.956,5.89H139.7a5.945,5.945,0,0,0,5.778-4.457H134.941a5.36,5.36,0,1,1,0-10.719h10.716v-2.527A5.868,5.868,0,0,0,145.353,220.893Z",
    transform: "translate(-115.59 -210.178)",
    fill: "#a1a1a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13138",
    "data-name": "Path 13138",
    d: "M190.17,295.637a4.315,4.315,0,0,0,4.315,4.315h10.706l.01-8.632H194.485A4.317,4.317,0,0,0,190.17,295.637Zm6.591,0a2.273,2.273,0,1,1-2.273-2.273A2.273,2.273,0,0,1,196.761,295.637Z",
    transform: "translate(-175.138 -275.218)",
    fill: "#a1a1a1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB3);
export default __webpack_public_path__ + "static/media/b3.94c1d18eaf8f71248df9d92bfe64442d.svg";
export { ForwardRef as ReactComponent };